import { navigationItems } from "./navigationItems.js";

export function DesktopNavigation({ items = navigationItems } = {}) {
  const navigation = document.createElement("nav");
  const fragment = document.createDocumentFragment();

  navigation.className = "menu";
  navigation.setAttribute("aria-label", "Primary navigation");

  items.forEach(({ label, href }) => {
    const link = document.createElement("a");

    link.className = "navlink";
    link.href = href;
    link.textContent = label;
    fragment.append(link);
  });

  navigation.append(fragment);

  return navigation;
}
